import "./Input.css";
import { randomUUID } from "../../axios_with_token";

export default function Input({fldName, form, fldDef, opts}){
    opts = opts || {};
    const {onChange, ...rest} = form.register(fldName, {
        // required: `${fldName} required.`,
        // pattern: {
        //     value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        //     message: "Please enter a valid email"
        // }
    })

    const datalistId = `datalistid-${randomUUID()}`;
    return <>
        <input
            className="form-control"
            type={opts.type || "text"}
            id={fldName}
            name={fldName}
            title={opts.tip || `${fldName}: ${(form.getValues()||{})[fldName]}`}
            onChange={evt=>{
                onChange(evt);
                // const cb = props.setFormValue.fldRefs.current[`${fldName}-chgCb`];
                // cb&&cb();
            }}
            list={datalistId} 
            {...rest}
        />
        {opts.datalist&&<datalist id={datalistId}>
            {
                opts.datalist.map(datalistItem=>{
                    const [val, caption] = datalistItem.constructor==Array?datalistItem:[datalistItem,datalistItem];
                    return <option
                        key={val}
                        value={val}
                    >{caption}</option>;
                })
            }
        </datalist>}
        {form.formState.errors[fldName] && <p className="fld-error">{form.formState.errors[fldName].message}</p>}
    </>;
}